import { useState } from "react";
import PropTypes from "prop-types";
import { Segmented } from "antd";
import FaxLogView from "./FaxLogView";
import OutboundLineLogView from "./OutboundLineLogView";
import { MetaText } from "../FaxStyled";

/**
 * Intake tab: the intake team's own fax line, with received and sent
 * faxes kept as two separate logs. Sending is unchanged — pick this
 * line in "Send from" on the Send Fax tab.
 */
const IntakeFaxView = ({ line }) => {
  const [direction, setDirection] = useState("inbound");

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          padding: "16px 24px 0",
        }}
      >
        <Segmented
          value={direction}
          onChange={setDirection}
          options={[
            { value: "inbound", label: "Received" },
            { value: "outbound", label: "Sent" },
          ]}
          data-testid="intake-fax-direction"
        />
        <MetaText>Intake fax line {line}</MetaText>
      </div>
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
        {direction === "inbound" ? (
          <FaxLogView line={line} />
        ) : (
          <OutboundLineLogView line={line} />
        )}
      </div>
    </div>
  );
};

IntakeFaxView.propTypes = {
  line: PropTypes.string.isRequired,
};

export default IntakeFaxView;
